// 動画再生速度の変更
$(() => {
  const videos = $('.video')

  // findIndex使用のため、配列風objを配列に変換
  const speedSelectBox = Array.from(document.querySelectorAll('.speed_select_box'))

  speedSelectBox.forEach(selectbox => {
    selectbox.addEventListener('change', e => {

      // インデックス取得
      let index = speedSelectBox.findIndex(btn => btn === e.target)

      // playbackRateの変更
      videos[index].playbackRate = e.target.value
    })
  })
})